export default __webpack_public_path__ + "static/media/FPG.c17c5190.png";